export default __webpack_public_path__ + "static/media/comparison-nova-sm.67cce9fd.jpg";